export const envVariableTrue = (envVariable: string | undefined): boolean => {
  return (envVariable || "false").toLowerCase() === "true";
};
